export default "__VITE_ASSET__CwpB1yFn__"